export var socialmediaLinkedin = [
    'M4.69 14H2.2V5.99H4.69V14ZM3.44 4.9C2.65 4.9 2 4.24 2 3.44C2 2.65 2.65 2 3.44 2C4.24 2 4.88 2.65 4.88 3.44C4.88 4.24 4.24 4.9 3.44 4.9ZM14 14H11.51V10.1C11.51 9.17 11.5 7.98 10.22 7.98C8.93 7.98 8.73 8.99 8.73 10.03V14H6.24V5.99H8.63V7.08H8.66C9 6.45 9.81 5.79 11.02 5.79C13.54 5.79 14 7.45 14 9.6V14H14Z',
];
